import type {
  FlagValueInterceptor,
  Value,
} from '@spotify/confidence-flag-evaluation-react';

import { useIsImpersonating } from './impersonationStore';

const FLAGS_PINNED_WHILE_IMPERSONATING = ['devbar'];

const pin = <T>(flag: string, value: T): T =>
  FLAGS_PINNED_WHILE_IMPERSONATING.includes(flag) &&
  typeof value === 'object' &&
  value !== null
    ? ({ ...value, enabled: true } as T)
    : value;

export const usePinnedDevbarFlag: FlagValueInterceptor = <T extends Value>(
  flag: string,
  _defaultValue: T,
  resolvedValue: T,
): T => (useIsImpersonating() ? pin(flag, resolvedValue) : resolvedValue);
